<template>
  <keep-alive>
    <div class="page">
      <query-select
        class="query-box"
        ref="queryselect"
      ></query-select>
      <div class="page-header white-bg">
        <size-change @sizeChange="sizeChange"></size-change>
        <div class="header-right">
          <vs-input
            class="search-words"
            v-model="words"
            placeholder="商户订单号/子订单号"
          ></vs-input>
          <vs-button class="search-btn" type="filled" color="primary" @click="toQuery">搜索</vs-button>
        </div>
      </div>
      <div class="page-content white-bg">
        <vs-table :data="listData">
          <template slot="thead">
            <vs-th>
              平台订单号
            </vs-th>
            <vs-th>
              商户订单号
            </vs-th>
            <vs-th>
              商户
            </vs-th>
            <vs-th>
              金额(USDT)
            </vs-th>
            <vs-th>
              钱包余额(USDT)
            </vs-th>
            <vs-th>
              订单时间
            </vs-th>
            <vs-th class="status-col">
              完成状态
            </vs-th>
            <vs-th class="notify-col">
              通知商户
            </vs-th>
            <vs-th>
              操作
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr :key="index" v-for="(tr, index) in data" >
              <vs-td>
                {{tr.serialNo}}
              </vs-td>
              <vs-td>
                {{tr.merOrderNo}}
              </vs-td>
              <vs-td>
                {{tr.merName}}
              </vs-td>

              <vs-td>
                <div>{{tr.amount}}</div>
              </vs-td>
              <vs-td>
                <div>{{tr.walletUsdtBalance}}</div>
              </vs-td>
              <vs-td>
                {{tr.create_time}}
              </vs-td>

              <vs-td class="status-col">
                <span
                  class="status"
                  :class="{
                  grey: tr.payStatus == 201 || tr.payStatus == 205 || tr.payStatus == 206,
                   green: tr.payStatus == 202,
                   red: tr.payStatus == 203,
                   orange: tr.payStatus == 204
                   }"
                >{{getState(tr)}}</span>
              </vs-td>
              <vs-td>
                <span
                  class="notify-merchan status"
                  :class="{
                    red: tr.notifyStatus != 2,
                    green: tr.notifyStatus == 2,
                  }"
                >{{ getNotify(tr) }}</span>
              </vs-td>
              <vs-td>
                <div class="centerx">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="查看"
                    placement="top"
                  >
                    <icon-svg
                      icon-class="eye"
                      class="pointer edit-icon mar-right10"
                      @click.native="checkHandle(tr)"
                    ></icon-svg>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="通知商户"
                    placement="top"
                    v-if="tr.payStatus == 202"
                  >
                    <icon-svg
                      icon-class="navigation"
                      class="pointer edit-icon mar-right10"
                      @click.native="notifyHandle(tr)"
                    ></icon-svg>
                  </el-tooltip>
                   <el-tooltip
                    class="item"
                    effect="dark"
                    content="手动归集"
                    @click.native="manualCollection(tr)" 
                    placement="top"
                  >
                    <svg t="1760512165489" class="icon manualCollection" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1621" width="20" height="20"><path d="M934.697674 465.562791c-65.488372-39.293023-105.972093-110.734884-105.972093-186.939535v-190.511628c0-15.47907-13.097674-28.576744-28.576744-28.576744H230.995349C214.325581 59.534884 202.418605 72.632558 202.418605 88.111628v189.32093c0 76.204651-40.483721 147.646512-105.972093 186.939535-10.716279 7.144186-20.24186 16.669767-26.195349 27.386047-5.953488 10.716279-9.525581 23.813953-9.525582 36.911627v384.595349c0 30.95814 25.004651 57.153488 57.153489 57.153489h797.767442c30.95814 0 57.153488-25.004651 57.153488-57.153489V529.860465c-1.190698-26.195349-15.47907-51.2-38.102326-64.297674z m-747.758139-2.381396c45.246512-50.009302 71.44186-116.688372 71.44186-185.748837V130.976744c0-8.334884 5.953488-14.288372 14.288372-14.288372h484.613954c8.334884 0 14.288372 5.953488 14.288372 14.288372v147.646512c0 69.060465 26.195349 135.739535 71.44186 185.748837 8.334884 9.525581 1.190698 23.813953-10.716279 23.813954h-110.734883c-5.953488 0-11.906977 3.572093-13.097675 9.525581l-15.479069 47.627907-11.906977 36.911628c-3.572093 11.906977-14.288372 19.051163-27.386047 19.051163H377.451163c-11.906977 0-22.623256-8.334884-27.386047-19.051163l-11.906976-36.911628-15.47907-47.627907c-2.381395-5.953488-7.144186-9.525581-13.097675-9.525581h-110.734883c-13.097674-1.190698-20.24186-15.47907-11.906977-25.004652z m0 0" p-id="1622" fill="#626262" data-spm-anchor-id="a313x.search_index.0.i8.11ae3a81yZEMqc" class="selected"></path><path d="M658.455814 230.995349h-285.767442c-15.47907 0-28.576744-13.097674-28.576744-28.576744 0-15.47907 13.097674-28.576744 28.576744-28.576745h284.576744c15.47907 0 28.576744 13.097674 28.576744 28.576745 1.190698 16.669767-11.906977 28.576744-27.386046 28.576744z m0 113.116279h-285.767442c-15.47907 0-28.576744-13.097674-28.576744-28.576744 0-15.47907 13.097674-28.576744 28.576744-28.576744h284.576744c15.47907 0 28.576744 13.097674 28.576744 28.576744 1.190698 16.669767-11.906977 28.576744-27.386046 28.576744z m0 114.306977h-285.767442c-15.47907 0-28.576744-13.097674-28.576744-28.576745 0-15.47907 13.097674-28.576744 28.576744-28.576744h284.576744c15.47907 0 28.576744 13.097674 28.576744 28.576744 1.190698 15.47907-11.906977 28.576744-27.386046 28.576745z m0 0" p-id="1623" fill="#989898"></path></svg>
                  </el-tooltip>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <div class="pagination-outer" v-if="total">
          <span class="tatol-count">共计{{total}}条</span>
          <vs-pagination
            class="pagination-box"
            :max="size"
            :total="pageSize"
            v-model="page"
          ></vs-pagination>
        </div>
      </div>
    </div>
  </keep-alive>
</template>

<script>
  import { notifyMerchant , collectMerWallet } from '@/api/wallet'
  import { mapGetters } from 'vuex'
  import { parseTime } from "../../../utils";
  import querySelect from '@/components/walletManage/api/querySelect'
  import initData from '@/mixins/initData'
  import sizeChange from '@/components/public/sizeChange'
  export default {
    name: "index",
    components:{
      sizeChange,
      querySelect,
    },
    mixins: [initData],
    computed: {
      ...mapGetters(['beforePage']),
    },
    mounted(){
      this.init();
    },
    methods: {
      beforeInit(){
        this.url = 'pms/crm/apiWalletTrans';
        if(this.beforePage){
          this.page = this.beforePage;
          this.$store.commit('setBeforePage', 0);
        }
        this.params = {
          page: this.page,
          size: this.size,
        };

        if(this.words){
          this.params.basicInfo = this.words;
        }
        if(this.$refs.queryselect.merchantCode){
          this.params.merCode = this.$refs.queryselect.merchantCode;
        }

        if(this.$refs.queryselect.payStatus){
          this.params.payStatus = this.$refs.queryselect.payStatus;
        }
        if(this.$refs.queryselect.orderDate && this.$refs.queryselect.orderDate.length){
          this.params.startTime = parseTime(this.$refs.queryselect.orderDate[0]);
        }
        if(this.$refs.queryselect.orderDate && this.$refs.queryselect.orderDate.length){
          this.params.endTime = parseTime(this.$refs.queryselect.orderDate[1]);
        }
        return true;
      },
      getState(tr){
        switch (+tr.payStatus) {
          case 201:
            return '未支付';
            break;
          case 202:
            return '支付成功';
            break;
          case 203:
            return '支付失败';
            break;
          case 204:
            return '支付中';
            break;
          case 205:
            return '已过期';
            break;
          case 206:
            return '转账退款';
            break;
        }
      },
      manualCollection(tr){
        collectMerWallet({
          orderSerialNo: tr.serialNo,
        }).then((res) => {
          this.$vs.notify({
            text: '操作成功',
            position: 'top-right'
          });
          this.init();
        })
      },
      checkHandle(tr){
        this.$router.push({name: 'apiTurnoverDetail', params:{id: tr.serialNo},query:{page: this.page} });
      },
      notifyHandle(tr){
        notifyMerchant({
          serialNo: tr.serialNo,
        }).then((res) => {
          console.log(res);
          this.$vs.notify({
            text: '已通知商户',
            position: 'top-right'
          });
          this.init();
        })
      },
      getNotify(tr){
        return tr.notifyStatus == 2 ? '是': '否';
      }
    },
  }
</script>
<style lang="scss">
  .page {
    .vs-table--thead th {
      padding-top: 17px!important;
      padding-bottom: 17px!important;
      color: #5E5873;
      background-color: #F3F2F7;
    }
  }
</style>
<style lang="scss" scoped>
  .centerx {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .query-box {
    margin-bottom: 1.7rem;
  }
  .page-header {
    display: flex;
    justify-content: space-between;
    padding: 1.4rem;
    .header-right {
      .search-words {
        display: inline-block;
      }
      .search-btn,
      .search-words {
        margin-right: 10px;
      }
    }
  }
  .page-content {
    padding-bottom: 1.4rem;
  }
  .merchant-info {
    display: flex;
    justify-content: flex-start;
    align-items: center;

  }
  .edit-icon {
    font-size: 22px;
  }
  .status {
    display: inline-block;
    padding: 5px 10px;
    border-radius: 17px;
    &.red {
      background-color: rgba(234, 84, 85, 0.12);
      color: #EA5455;
    }
    &.green {
      background: rgba(40, 199, 111, 0.12);
      color: #41B883;
    }
    &.orange {
      background-color: rgba(255, 165, 0, 0.12);
      color: orange;
    }
    &.grey {
      background-color: rgba(128, 128, 128, 0.12);
      color: grey;
    }
  }
  .status-col {
    min-width: 120px;
  }
  .manualCollection{
    cursor: pointer;
  }
</style>
